import ErrorComponent from "../components/global/ErrorComponent";
import "./Error404.css";

const Error1 = () => {
  return (
    <div className="error">
      <img className="caution-error-1-icon" alt="" src="/serverError.png" />
      <div className="error-content-wrapper">
        <ErrorComponent
          missingLink="404"
          pageNotFound=""
          pageNotFound1="Page Not Found "
        />
      </div>
    </div>
  );
};

export default Error1;
